/**
 * @generated SignedSource<<c24a11428cf92ee4604e2b793b9468b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_businessTimeline_TimelineViewRoot$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueCreateContext_businessIssueCreate_IssueCreateProvider">;
  readonly " $fragmentType": "main_businessTimeline_TimelineViewRoot";
};
export type main_businessTimeline_TimelineViewRoot$key = {
  readonly " $data"?: main_businessTimeline_TimelineViewRoot$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_businessTimeline_TimelineViewRoot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_businessTimeline_TimelineViewRoot",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "issueCreateContext_businessIssueCreate_IssueCreateProvider"
    }
  ],
  "type": "Query"
};

(node as any).hash = "1f4b7b45f01ad2194bdd0747740714a5";

export default node;
